import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { ConflictWarning } from './calendarTypes';

interface CalendarConflictWarningProps {
  conflicts: ConflictWarning[];
}

export const CalendarConflictWarning: React.FC<CalendarConflictWarningProps> = ({ conflicts }) => {
  if (conflicts.length === 0) return null;

  const tooltipText = conflicts.map(c => c.message).join('\n');

  return (
    <Tooltip title={tooltipText}>
      <Chip
        icon={<WarningAmberIcon />}
        label={`${conflicts.length} conflict${conflicts.length > 1 ? 's' : ''}`}
        color="warning"
        size="small"
        variant="outlined"
      />
    </Tooltip>
  );
};
